import { DashboardTimeRangePreset } from 'pages/Dashboard/DeskActivityOverviewDashboard/components/TimeRangeFilterButton';
import {
    createHashStore,
    HashStoreConfig,
    serializers,
} from 'pages/Dashboard/utils/createHashStore';

const TIME_RANGE_VALUES: readonly DashboardTimeRangePreset[] = [
    'last-7-days',
    'last-30-days',
    'last-90-days',
    'last-quarter',
    'last-year',
    'last-2-years',
    'all-time',
] as const;

type State = {
    startDateTime: Date;
    endDateTime: Date;
    locationIds: string[];
    timeRange: DashboardTimeRangePreset;
};

type Actions = {
    setStartDateTime: (date: Date) => void;
    setEndDateTime: (date: Date) => void;
    setLocationIds: (ids: string[]) => void;
    setTimeRange: (range: DashboardTimeRangePreset) => void;
};

function getDefaultState(): State {
    const now = new Date();
    const thirtyDaysAgo = new Date(now);
    thirtyDaysAgo.setDate(now.getDate() - 30);

    return {
        startDateTime: thirtyDaysAgo,
        endDateTime: now,
        locationIds: [],
        timeRange: 'last-30-days',
    };
}

const hashConfig: HashStoreConfig<State> = {
    startDateTime: {
        paramName: 'startDate',
        ...serializers.date,
    },
    endDateTime: {
        paramName: 'endDate',
        ...serializers.date,
    },
    locationIds: {
        paramName: 'locations',
        ...serializers.stringArray,
    },
    timeRange: {
        paramName: 'timeRange',
        ...serializers.enum<DashboardTimeRangePreset>(TIME_RANGE_VALUES),
    },
};

export const useValueByLocationFiltersStore = createHashStore<State, Actions>(
    getDefaultState,
    hashConfig,
    (set) => ({
        ...getDefaultState(),
        setStartDateTime: (date) => set({ startDateTime: date }),
        setEndDateTime: (date) => set({ endDateTime: date }),
        setLocationIds: (ids) => set({ locationIds: ids }),
        setTimeRange: (range) => set({ timeRange: range }),
    }),
    'value-by-location-filters'
);
